import React from 'react';
import PropTypes from 'react';
import styled from 'styled-components';
import {
    PolicyLetterSection,
    PolicyContentTable,
} from '../../components/lin/linSharedElements'
const PaymentPlan = ({ ledgerData }) => {
    const formatDate = date => {
        const d = new Date(date);

        return d.toLocaleString('no-NO', {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
        });
    };

    return (
        <PolicyLetterSection>
            <MaxusPolicyContentTable>
                <thead>
                    <tr>
                        <th>Nummer</th>
                        <th>Betald</th>
                        <th>Dag</th>
                        <th>Belopp</th>
                    </tr>
                </thead>
                <tbody>

                    {ledgerData.map((item, index) => (
                        <tr key={index}>
                            <td>{item.index}</td>
                            <td>{item.collected ? 'Ja' : '-'}</td>
                            <td>{item.collectionDay}</td>
                            <td>{item.amount.toLocaleString('sv-SE', {
                                maximumFractionDigits: 0,
                            })} kr</td>
                        </tr>
                    ))}
                </tbody>
            </MaxusPolicyContentTable>
        </PolicyLetterSection>
    );
};

export default PaymentPlan;

const MaxusPolicyContentTable = styled(PolicyContentTable)`
  font-family: 'din-condensed';
  font-weight: 300;

  thead {
    th {
      font-weight: 400;
    }
  }
`;

